'use strict';

basecoat.notificationLimit = 3;
basecoat.notificationCount = 0;
basecoat.notificationMoreCount = 0;
basecoat.notificationModalHtml = '' +
'<div class="modal fade full-modal notification-modal" id="notificationModal" tabindex="-1" role="dialog" aria-labelledby="notificationModalLabel">' +
  '<div class="modal-dialog" role="document">' +
    '<div class="modal-content">' +

      '<div class="modal-header">' +
        '<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>' +
        '<h4 class="modal-title" id="notificationModalLabel">' +
          '<span class="fa fa-flag"></span> Notifications' +
        '</h4>' +
      '</div>' +

      '<div class="delete-all fade in"><span data-notifications-count-plural="There are <strong>#</strong> notifications." data-notifications-count-singular="There is <strong>#</strong> notification."></span> <a class="pull-right" data-dismiss="allNotifications">Delete all</a></div>' +

      '<div class="modal-body scrollbars scrollbars-light">' +
        '<div class="notification-container">' +

          '<div class="notification-feed"></div>' +

          '<a class="show-more fade" data-toggle="notificationsModal">There are <strong><span data-notifications-more-count>0</span> more</strong> notifications. Click to view all.</a>' +

        '</div>' +
      '</div>' +

    '</div>' +
  '</div>' +
'</div>';

+function ($) {

  var $modal, $container;

  // leave the dom uncluttered until such a time that notifications are used. that's when this function will be called.
  basecoat.initNotificationModal = function () {
    if ($modal) return $modal; // only execute on the first time

    // create the notification modal (if it doesn't exist)
    $modal = $('#notificationModal');
    if ($modal.length == 0) {
      $modal = $(basecoat.notificationModalHtml).appendTo('body');
      $modal.find('.scrollbars').scrollbar();
    }

    // create the floating notifications container based off the modal
    $container = $modal.find('.notification-container').clone(true);
    $('body').append($container);

    // update (initialize) any counters on the DOM
    basecoat.updateNotificationCounters();

    $modal
    // show modal: move notifications to inside the modal
    .on('show.bs.modal', function () {
      $container = $('body .notification-container:last').clone(true);
      $modal.find('.notification-container').replaceWith($container);
    })
    // hide modal: make notifications floaty
    .on('hide.bs.modal', function () {
      $container = $modal.find('.notification-container').clone(true);
      $('body .notification-container:last').replaceWith($container);
    });

    $(document)
    // dismiss notification
    .on('click.bc.notification', '[data-dismiss="notification"]', function () {
      $(this).closest('.notification-alert').trigger('hide');
    })
    // dismiss all-notifications
    .on('click.bc.notification', '[data-dismiss="allNotifications"]', function () {
      $('.notification-alert').remove();
      basecoat.updateNotificationCounters();
      $modal.modal('hide');
    });
  };

  // update all variables/badges/display of notification counters found on a page
  basecoat.updateNotificationCounters = function () {
    basecoat.notificationCount = $container.find('.notification-feed .notification-alert:not(.out)').length;
    basecoat.notificationMoreCount = Math.max(0, basecoat.notificationCount - basecoat.notificationLimit);

    // update simple counters on the page
    $('[data-notifications-more-count]').text(basecoat.notificationMoreCount);
    $('[data-notifications-count-not-empty]').text(basecoat.notificationCount > 0 ? basecoat.notificationCount : '');
    $('[data-notifications-count]').text(basecoat.notificationCount);

    // correct language for singular or plural notification count
    var multiple = basecoat.notificationCount == 1 ? 'singular' : 'plural';
    $('[data-notifications-count-' + multiple + ']').html(function () {
      return $(this).data('notifications-count-' + multiple).replace(/#/g, basecoat.notificationCount);
    });

    // if there aren't any more notifications then hide the "show more" link
    if (basecoat.notificationMoreCount < 1) {
      $container.find('.show-more').removeClass('in');
    }

    // if there are too many notifications
    if (basecoat.notificationMoreCount > 0) {
      // display "show more" link
      $container.find('.show-more').addClass('in');
      // hide excess notifications
      $container.find('.notification-feed .notification-alert:not(.out):gt(' + (basecoat.notificationLimit - 1) + ')').removeClass('in');
    }
  };

  // create a new notification with show and hide events
  basecoat.notification = function (heading, message, footnote) {
    basecoat.initNotificationModal();

    // generate new notification
    return $(
      '<div class="notification-alert fade">' +
        (heading ? '<h5 class="heading">' + heading + '</h5>' : '') +
        (message ? '<p class="message">' + message + '</p>' : '') +
        (footnote ? '<p class="footnote">' + footnote + '</p>' : '') +
        '<span class="close" data-dismiss="notification"></span>' +
      '</div>'
    )

    // show the notification
    .on('show.bc.notification', function (e) {
      e.stopPropagation();

      // prepend to the feed
      var $notification = $(this);
      $container.find('.notification-feed').prepend($notification);
      $notification[0].offsetWidth; // forces reflow before applying fade in effect
      $notification.addClass('in');

      // update counters
      basecoat.updateNotificationCounters();
    })

    // dismiss the notification
    .on('hide.bc.notification', function (e) {
      e.stopPropagation();

      // remove any that are still busy animating
      $container.find('.notification-feed notification-alert.fade.out').remove();

      // remove this notification from the feed
      var $notification = $(this);
      $notification.addClass('out').removeClass('in');
      window.setTimeout(function () { $notification.remove(); }, 1000);

      // make sure the newest notifications are visible
      $container.find('.notification-feed .notification-alert:not(.out):lt(' + basecoat.notificationLimit + ')').addClass('in');

      // update counters
      basecoat.updateNotificationCounters();

      // if that was the last notification then close the modal
      if ($modal.hasClass('in') && basecoat.notificationCount < 1) {
        $modal.modal('hide');
      }
    });
  };

  $(document)
  // show/hide the notifications modal
  .on('click.bc.notification', '[data-toggle="notificationsModal"]', function () {
    basecoat.initNotificationModal();
    $modal.modal('toggle');
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/notification.js
// module id = 10
// module chunks = 0